
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.27 18.561"}},[_c('path',{attrs:{"d":"M2.723 17.167l.464.233c1.088.54 2.835.492 3.883-.11l3.887-2.218c1.053-.602 1.93-2.086 1.93-3.297v-2.21a16.573 16.573 0 0116.495.002v2.21c0 1.212.877 2.694 1.93 3.296l3.887 2.223c1.052.6 2.8.648 3.884.107l.465-.232c1.085-.543 1.972-1.978 1.972-3.19l-.002-3.306c.002-.589-.65-1.618-.653-1.62A27.602 27.602 0 0021.14.75 27.607 27.607 0 001.457 9.006c-.027.027-.706 1.077-.707 1.666v3.305c0 1.212.888 2.647 1.973 3.19z","stroke":"currentColor","stroke-width":"1.5","fill":"none"}})])
      }
    
      }
    